// src/components/PushToGitHub.jsx
import { useState } from "react";
export default function PushToGitHub({
  content = {},
  defaultSlug = "neuer-artikel",
  githubToken,
  githubOwner,
  githubRepo,
}) {
  const [slug, setSlug] = useState(defaultSlug);
  const [status, setStatus] = useState(null);

  const branch = "main";

  async function pushToGitHub() {
    if (!slug) return setStatus("❌ Slug fehlt!");
    if (!githubToken) return setStatus("❌ Kein Token vorhanden!");

    setStatus("🔄 Push läuft...");
    const fileContent = JSON.stringify(content, null, 2);
    const path = `src/data/articles/${slug}.json`;
    const message = `chore(blog): Artikel hinzugefügt: ${slug}`;

    try {
      const res = await fetch(`https://api.github.com/repos/${githubOwner}/${githubRepo}/contents/${path}`, {
        headers: { Authorization: `token ${githubToken}` }
      });
      const existing = res.ok ? await res.json() : null;

      const payload = {
        message,
        branch,
        content: btoa(unescape(encodeURIComponent(fileContent))),
        ...(existing?.sha && { sha: existing.sha })
      };

      const githubRes = await fetch(`https://api.github.com/repos/${githubOwner}/${githubRepo}/contents/${path}`, {
        method: "PUT",
        headers: {
          Authorization: `token ${githubToken}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });

      if (!githubRes.ok) throw new Error("Fehler beim Pushen");
      setStatus("✅ Erfolgreich gepusht nach GitHub!");
    } catch (e) {
      console.error(e);
      setStatus("❌ Fehler beim Push.");
    }
  }

  return (
    <div className="space-y-4 p-4 bg-gray-50 rounded-xl shadow-md">
      <h3 className="font-bold text-lg">🧠 Push Blogartikel zu GitHub</h3>

      <label className="block">
        Slug:
        <input
          type="text"
          className="border p-2 w-full mt-1"
          value={slug}
          onChange={(e) => setSlug(e.target.value)}
        />
      </label>

      <button
        onClick={pushToGitHub}
        className="px-4 py-2 bg-black text-slate-50 font-mono rounded hover:bg-gray-800"
      >
        🚀 Push zu GitHub
      </button>

      {status && <p className="text-sm font-mono text-gray-700 mt-2">{status}</p>}
    </div>
  );
}

